export const LISTS_RECEIVED = "LISTS_RECEIVED";
export const LIST_RECEIVED = "LIST_RECEIVED";
export const LIST_REMOVED = "LIST_REMOVED";
export const LOOKUP_DATA_RECEIVED = "LOOKUP_DATA_RECEIVED";
export const LOOKUPTYPES_RECEIVED = "LOOKUPTYPES_RECEIVED";
